(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["epf-pulse-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  var tabs = document.querySelectorAll('.epf-specs__tab');
  if (!tabs.length) return;
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var panel = this.dataset.epfTab;
      document.querySelectorAll('.epf-specs__tab').forEach(function (t) {
        t.classList.remove('epf-specs__tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.epf-specs__panel').forEach(function (p) {
        p.classList.remove('epf-specs__panel--active');
      });
      this.classList.add('epf-specs__tab--active');
      this.setAttribute('aria-selected', 'true');
      var target = document.querySelector('[data-epf-panel="' + panel + '"]');
      if (target) target.classList.add('epf-specs__panel--active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scooter-pdp"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.scooter-pdp').forEach(function (pdp) {

  /* ── SPEC TABS ── */
  pdp.querySelectorAll('.pdp-specs__tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var t = this.dataset.tab;
      pdp.querySelectorAll('.pdp-specs__tab').forEach(function (el) {
        el.classList.remove('pdp-specs__tab--active');
        el.setAttribute('aria-selected', 'false');
      });
      pdp.querySelectorAll('.pdp-specs__panel').forEach(function (el) {
        el.classList.remove('pdp-specs__panel--active');
      });
      this.classList.add('pdp-specs__tab--active');
      this.setAttribute('aria-selected', 'true');
      var panel = pdp.querySelector('[id^="pdp-tab-' + t + '"]');
      if (panel) panel.classList.add('pdp-specs__panel--active');
    });
  });

  /* ── WERTGARANTIE TOGGLE ── */
  var wgOpts = pdp.querySelector('.pdp-wg__options');
  if (wgOpts) {
    var totalEl = pdp.querySelector('.pdp-wg__total-price');
    var basePrice = parseInt(wgOpts.dataset.basePrice || '0', 10);

    function formatMoney(cents) {
      return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    }

    wgOpts.querySelectorAll('.pdp-wg__option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        wgOpts.querySelectorAll('.pdp-wg__option').forEach(function (o) {
          o.classList.remove('pdp-wg__option--active');
        });
        this.classList.add('pdp-wg__option--active');
        var radio = this.querySelector('.pdp-wg__radio');
        if (radio) {
          radio.checked = true;
          var add = parseInt(radio.value || '0', 10);
          if (totalEl) totalEl.textContent = formatMoney(basePrice + add);
        }
      });
    });
  }

  /* ── FAQ aria-expanded ── */
  pdp.querySelectorAll('.pdp-faq__item').forEach(function (det) {
    var sum = det.querySelector('summary');
    det.addEventListener('toggle', function () {
      if (sum) sum.setAttribute('aria-expanded', det.open ? 'true' : 'false');
    });
  });
  }); /* end querySelectorAll('.scooter-pdp') */
})();

  } catch(e) { console.error(e); }
})();
})();
